import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ModalService } from "../../providers/modal/modal.service";
import { NgForOf, NgIf } from "@angular/common";
import { TrustpilotWidgetComponent } from "../trustpilot-widget/trustpilot-widget.component";

@Component({
    selector: 'vsf-layout-footer',
    templateUrl: './layout-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, NgForOf, NgIf, TrustpilotWidgetComponent]
})
export class LayoutFooterComponent {

    readonly columnLinks: Array<{
        heading: string;
        links: Array<{ label: string; route?: any[]; url?: string; }>
    }> = [
        {
            heading: 'About Us',
            links: [
                { label: 'About Us', route: ['/a', 'about-us'] },
                { label: 'Catalogue', route: ['/a', 'download-catalogue'] },
                { label: 'Blog', url: 'https://www.artsupplies.co.uk/blog/' },
                { label: 'Visit Our Shop', route: ['/a', 'visit-our-shop'] },
            ]
        },
        {
            heading: 'Shopping',
            links: [
                { label: 'Delivery', route: ['/a', 'delivery-information'] },
                { label: 'Returns', route: ['/a', 'returns'] },
                { label: 'Reward Points', route: ['/a', 'reward-points'] },
                { label: 'Price Match Promise', route: ['/a', 'price-match-promise'] },
            ]
        },
        {
            heading: 'Help',
            links: [
                { label: 'Contact Us', route: ['/a', 'contact-us'] },
                { label: 'FAQs', route: ['/a', 'faq'] },
                { label: 'Hints & Tips', route: ['/a', 'hints-tips-and-techniques'] },
            ]
        }
    ]

    constructor(private modalService: ModalService) {}

    private mailingListModalIsOpen = false;
    async openMailingListSignup(event?: MouseEvent) {
        if (event) {
            event.preventDefault();
        }
        const { MailingListDialogComponent } = await import('../../../mailing-list/components/mailing-list-dialog/mailing-list-dialog.component');
        if (this.mailingListModalIsOpen) {
            return;
        }
        this.mailingListModalIsOpen = true;
        this.modalService
            .fromComponent(MailingListDialogComponent, { size: 'md', closable: true })
            .subscribe(() => {
                this.mailingListModalIsOpen = false;
            });
    }
}
